import Vue from 'vue';
import Vuex from 'vuex';

import urlsAPI from '../../config/urlsAPI';
import handlerError from '../../utils/errors';
import { axiosInstance } from '../../main';

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    expenses: [],
    expense: {
      documentNr: '',
      description: '',
      amount: 0,
      date: '',
    },
  },
  mutations: {
    updateExpense(state, element) {
      state.expense = element;
    },
    updateExpenses(state, alerts) {
      state.expenses = alerts;
    },
    addExpense(state, element) {
      state.expenses.push(element);
    },
    putExpense(state, element) {
      state.expenses = state.expenses.map((value) => (element.id === value.id ? element : value));
    },
    deleteAction(state, id) {
      state.expenses = state.expenses.filter((el) => el.id !== id);
    },
  },
  actions: {

    getExpense({ commit }, id) {
      axiosInstance.get(urlsAPI.expensesURL + id)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateExpense', response.data);
          }
        })
        .catch(handlerError);
    },

    getExpenses({ commit }, {paymentType}) {
      axiosInstance.get(`${urlsAPI.expensesByPaymentTypesURL}${paymentType}`)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateExpenses', response.data);
          }
        })
        .catch(handlerError);
    },

    createExpense({ commit }, body) {
      axiosInstance.post(urlsAPI.expensesURL, body)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('addExpense', response.data);
          }
        })
        .catch(handlerError);
    },

    updateExpense({ commit }, { id, body }) {
      axiosInstance.put(urlsAPI.expensesURL + id, body)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('putExpense', response.data);
          }
        })
        .catch(handlerError);
    },

    delete({ commit }, id) {
      axiosInstance.delete(urlsAPI.expensesURL + id)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('deleteAction', id);
          }
        })
        .catch(handlerError);
    },

    async getCashRegister(_, { start, end }) {
      return axiosInstance.get(urlsAPI.cashRegisterExportExcelURL, {
        params: {
          start,
          end,
        },
        responseType: 'blob',
      })
        .then((response) => {
          if (response.data.error) {
            return handlerError(response.data.error);
          }
          return response;
        })
        .catch(handlerError);
    },

    async getVATReport(_, { start, end }) {
      return axiosInstance.get(urlsAPI.vatReportExportExcelURL, {
        params: {
          start,
          end,
        },
        responseType: 'blob',
      })
        .then((response) => {
          if (response.data.error) {
            return handlerError(response.data.error);
          }
          return response;
        })
        .catch(handlerError);
    },

    async updateCashRegister(_, body) {
      return axiosInstance.put(urlsAPI.cashRegisterUpdateProfitURL, body)
        .then((response) => {
          if (response.data.error) {
            return handlerError(response.data.error);
          }
          return response;
        })
        .catch(handlerError);
    },
  },
};
